
import {Mode, StepDefinition} from "../models/steps";
import {DimensionChat} from "./DimensionChat";
import {StepState, Turn} from "../models/assessment";


interface DimensionPanelProps {
    stepDef: StepDefinition;
    stepState: StepState;
    mode: Mode;
    onAppendTurn: (turn: Turn) => void;
}

export function DimensionPanel({ stepDef, stepState, mode, onAppendTurn }: DimensionPanelProps) {
    return (
        <div className="w-full">
            <DimensionChat
                mode={mode}
                step={stepDef}
                history={stepState.history}
                onAppendTurn={onAppendTurn}
            />
        </div>
    );
}

